import type { PropsWithChildren } from 'react';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { convertCoopLocale } from '~/i18n';

const setHideCoopMenu = (value: string) => {
  localStorage.setItem('container-nav-enabled', value);
};

const getLocaleFromStorage = () => {
  const userLocale = localStorage.getItem('userLocale');

  if (userLocale) {
    try {
      return convertCoopLocale(JSON.parse(userLocale));
    } catch (e) {
      console.error('Error parsing userLocale from localStorage:', e);
    }
  }

  return 'en-US';
};

export function LocaleProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    setHideCoopMenu('hide');
  }, []);

  const { i18n } = useTranslation();

  const updateCurrentLocale = useCallback(
    (locale: string) => {
      i18n.changeLanguage(locale);
    },
    [i18n],
  );

  const onLocalStorageChanged = useCallback(
    (event: CustomEvent) => {
      if (event.detail.key === 'userLocale') {
        updateCurrentLocale(getLocaleFromStorage());
      }
    },
    [updateCurrentLocale],
  );

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    window.addEventListener('localStorageChanged', onLocalStorageChanged);

    return () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      window.removeEventListener('localStorageChanged', onLocalStorageChanged);
    };
  }, [onLocalStorageChanged]);

  return children;
}

LocaleProvider.displayName = 'LocaleProvider';
